import React from 'react';

const SIZES = { sm: 32, md: 44, lg: 64 };

// Allow app-relative paths and http(s) URLs only; escape CSS-significant
// characters so the value cannot alter the url() token. Anything else
// (javascript:, data:, etc.) falls back to initials.
export function safeCssUrl(src) {
  // Reject protocol-relative "//host/..." URLs, which the leading-"/" allowance would otherwise accept.
  if (typeof src !== 'string' || src.startsWith('//')) return null;
  if (!/^(https?:\/\/|\/)/i.test(src)) return null;
  // Manual %XX escaping covers CSS-significant chars encodeURIComponent leaves
  // alone (( ) '), but is only valid for single-byte code points; non-ASCII
  // whitespace (e.g. U+00A0) needs UTF-8 percent-encoding via encodeURIComponent.
  return src.replace(/[\\"'()\s]/g, (c) =>
    c.charCodeAt(0) < 0x80 ? '%' + c.charCodeAt(0).toString(16).padStart(2, '0') : encodeURIComponent(c)
  );
}

/** Round avatar with image or initials fallback. */
export default function Avatar({ src, name = '', size = 'md', tone = 'science', style, ...rest }) {
  const px = SIZES[size] || (typeof size === 'number' ? size : 44);
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();
  const bg = tone === 'human' ? 'var(--human-100)' : tone === 'ink' ? 'var(--neutral-900)' : 'var(--science-200)';
  const fg = tone === 'ink' ? '#fff' : 'var(--ink)';
  const imageUrl = src ? safeCssUrl(src) : null;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: px, height: px, borderRadius: 'var(--radius-pill)',
      background: imageUrl ? `center/cover no-repeat url("${imageUrl}")` : bg,
      color: fg, fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-bold)',
      fontSize: px * 0.36, letterSpacing: 0, overflow: 'hidden', flex: 'none', ...style,
    }} {...rest}>
      {!imageUrl && initials}
    </span>
  );
}
